module.exports = __webpack_public_path__ + "img/presence.9a0867dd.svg";